import { Component, input, computed, ChangeDetectionStrategy, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";
import { cn } from "../utils/utils";

@Component({
  selector: "div[agentChatToolbar]",
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    "[class]": "computedClass()",
  },
  template: `<ng-content></ng-content>`,
})
export class AgentChatToolbar {
  readonly inputClass = input<string | undefined>();

  readonly computedClass = computed(() => cn("achat-toolbar", this.inputClass()));
}
